module.exports = __webpack_public_path__ + "static/005_001-3a61bc69c000553fc21564ad63d21c79.jpg";